<template>
<div class="bgc">
  <div class="title">
    <span @click="$router.push('/home/role')">返回</span>

  </div>
  <div class="information_box">
    <div class="information_title">基本信息</div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" style="width: 600px">
      <el-form-item label="角色名称：" prop="name">
        <el-input v-model="ruleForm.name" maxlength="16"></el-input>
      </el-form-item>
      <el-form-item label="角色描述：" prop="desc">
        <el-input type="textarea" v-model="ruleForm.desc" resize="none" maxlength="100" :autosize="{ minRows: 4, maxRows: 4 }"></el-input>
      </el-form-item>
      <el-form-item label="角色互斥：">
        <el-radio-group v-model="ruleForm.mutualroles">
          <el-radio label="是"></el-radio>
          <el-radio label="否"></el-radio>
        </el-radio-group>
        <div v-if="ruleForm.mutualroles=='是'">
          <el-select v-model="ruleForm.region" multiple style="width: 500px">
            <el-option v-for="item in ruleForm.roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="角色状态：">
        <el-radio-group v-model="ruleForm.resourcetwo">
          <el-radio label="启用"></el-radio>
          <el-radio label="禁用"></el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
  <div class="mtp24">
    <!-- <button @click="dainwo">点我</button> -->
    <el-tabs v-model="activeName" @tab-click="handleClick" class="padd44">
      <el-tab-pane label="操作权限" name="操作权限" style="font-size: 16px;">
        <ul v-if="checkedCities.length>0">
          <li v-for="item in permissionList" :key="item.id">
            <checkbox :NameAll="item" ref="checkBoxRef" :checkActCities="checkedCities"></checkbox>
          </li>
        </ul>
        <ul v-else>
          <li v-for="item in permissionList" :key="item.id">
            <checkbox :NameAll="item" ref="checkBoxRef"></checkbox>
          </li>
        </ul>
      </el-tab-pane>
    <el-tab-pane label="数据权限" name="数据权限" style="font-size: 16px;">
        <div class="inforNowPer_box">
          <div class="information_title">数据权限（控制该角色用户能够看到的数据范围）</div>
        </div>
          <ul v-if="AuthorityData.length>0" >
            <li v-for="item in NowPerList" :key="item.id">
              <Roadiu :RoadiuItem="item"  ref="RoadiuBoxRef" :Authority='AuthorityData'></Roadiu>
            </li>
          </ul>
          <ul v-else >
            <li v-for="item in NowPerList" :key="item.id">
              <Roadiu :RoadiuItem="item" ref="RoadiuBoxRef"></Roadiu>
            </li>
          </ul>
      </el-tab-pane>
    </el-tabs>
    <div class="Foot">
      <el-button @click="Delete">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from "vuex";
import Roadiu from "./Roadiu.vue";
import checkbox from './checkout.vue'
// import checkbox from "./common/checkout.vue";
export default {
  components: {
    checkbox,
    Roadiu
  },
  data() {
    return {
      activeName: "操作权限",
      isIndeterminate: true,
      checkedCities: [],
      checkAll: false,
      permissionList: [], //操作权限的数据
      PerIDAllList: [], //选中的权限ID数据
      ruleForm: {
        name: "", //名字
        roleList: [], //互斥的数组
        region: [], //互斥选项
        desc: "", //角色描述：
        resourcetwo: "启用", //角色状态：
        mutualroles: "否", //角色互斥：
      },
      rules: {
        name: [{
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 16,
            message: "长度在 1 到 16 个字符",
            trigger: "blur"
          },
        ],
        desc: [{
          required: true,
          message: "请填写角色描述",
          trigger: "blur"
        }],
      },
      NowPerList: [],
      ActiveNum: [], //选择数据权限的ID数组
      AuthorityData: [], //数据权限编辑的
      DataPermis: [], //角色获取到的数据权限
    };
  },
  created() {
    this.excludeRolesList()
    if (this.$route.query.role_id==0) {
     this.PerAllList()
    } else {
       this.GetRoleConet();
    }
  },
  mounted() {},
  watch: {},
  methods: {
    ...mapActions({
      MenuPermiList: "pressimApi/MenuPermiList",
      RoleConent: "pressimApi/RoleConent",
      rolesCreate: "pressimApi/rolesCreate",
      rolesEdit: "pressimApi/rolesEdit",
      excludeRoles: "pressimApi/excludeRoles",
      RoleData: "pressimApi/RoleData",
    }),
    async GetRoleData() { //获取数据权限
      let params = {
        role_id: 0,
        current_role_id: 0,
        platform_id: 2,
        token: this.$store.state.token
      };
      await this.RoleData(params).then((res) => {
        if (res.code === 1) {
          this.NowPerList = res.data;
        }
      });
    },
    excludeRolesList() {
      let data = {
        token: this.$store.state.token,
        platform_id: 2,
      };
      this.excludeRoles(data).then((res) => {
       
        if (res.code === 1) {
          this.ruleForm.roleList = res.data.list;
           console.log(this.roleList,'re----')
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    GettingData() {
      this.NowPerList.forEach((item, index) => {
        if (this.$refs.RoadiuBoxRef[index].value) {
          let item = {}
          if (this.$refs.RoadiuBoxRef[index].value === '全公司') {
            item.option = 1,
              item.id = this.$refs.RoadiuBoxRef[index].RoadiuItem.id
          } else {
            item.option = 2,
              item.id = this.$refs.RoadiuBoxRef[index].RoadiuItem.id
          }
          this.ActiveNum.push(item)
        }
      });
    },
    Delete() {},
    async save() {
      this.permissionList.forEach((item, index) => {
        this.$refs.checkBoxRef[index].getData();
        this.PerIDAllList = [...this.$refs.checkBoxRef[index].PerIDList, ...this.PerIDAllList, ];
      });
      await this.GettingData()
      this.rolesOPeration()

    },
    rolesOPeration() {
      let params = {
        token: this.$store.state.token,
        name: this.ruleForm.name, //角色名
        describe: this.ruleForm.desc, //描述
        is_exclude: this.ruleForm.mutualroles ? 0 : 1, //是否互斥，0不互斥，1互斥
        exclude_roles: this.ruleForm.region, //互斥角色id
        status: this.ruleForm.resourcetwo == '启用' ? 1 : 2, //状态 1启用，2禁用
        operate: Array.from(new Set(this.PerIDAllList)), //一个或多个权限id
        authority_data: this.ActiveNum,
        platform_id: 2
      }
      if (this.$route.query.role_id == undefined) {
        this.rolesCreate(params).then(res => {
          if (res.data.code == 1) {
            console.log(res, '-----')
            this.$message.success('创建成功')
            this.$router.push('/home/role')
          } else {
            console.log(res, '-----')
            this.$message.error(res.data.msg)
          }
        })
      } else {
        params.id = this.$route.query.role_id
        this.rolesEdit(params).then(res => {
          if (res.code == 1) {
            this.$message.success('修改成功')
            this.$router.push('/home/role')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }

    },
    GetRoleConet() {
      let roleID = this.$route.query.role_id
      let params = {
        token: this.$store.state.token,
        role_id: this.$route.query.role_id,
      }
      this.RoleConent(params).then(async res => {
        if (res.code == 1) {
          this.checkedCities = res.data.role_authority
          this.ruleForm.name = res.data.role.name,
            this.DataPermis = res.data
          // this.ruleForm.region=res.data.role.describe,
          this.ruleForm.desc = res.data.role.describe,
            this.ruleForm.resourcetwo = res.data.role.status === 1 ? '启用' : '禁用',
            this.AuthorityData = res.data.authority_data
          this.ruleForm.mutualroles = res.data.role.is_exclude === 0 ? '否' : '是'
          this.PerAllList();
        }
      })

    },
    async PerAllList() {
      let data = {
        token: this.$store.state.token,
        role_id: this.$route.query.role_id,
      };
      await this.MenuPermiList(data).then((res) => {
        if (res.code === 1) {
          this.permissionList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClick(tab, event) {
      //Tag选择事件
      console.log(tab.label);
      if (tab.label == "数据权限") {
        this.GetRoleData()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 66px;
  background: #fff;
  font-size: 20px;
  color: #000000;
  width: 100%;
  padding: 20px 32px 10px 32px;
  border-bottom: 2px solid #ccc;
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
}

.bgc {
  background-color: #e9e9e9;
  padding: 14px 24px;

  // height: 100%;
  .mtp24 {
    margin-top: 24px;
    padding: 0;
    background-color: #fff;

    .padd44 {
      padding: 16px 44px;
    }
  }

  .inforNowPer_box {
    font-size: 16px;

    .information_title {
      position: relative;
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      line-height: 56px;
      padding-left: 12px;
      background-color: #FAFAFA;

    }

    .information_title::after {
      content: "";
      position: absolute;
      top: 20px;
      left: 0px;
      background-color: #0084ff;
      width: 3px;
      height: 16px;
    }
  }

  .information_box {
    padding: 42px 44px;
    background-color: #fff;

    .information_title {
      position: relative;
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      line-height: 56px;
      padding-left: 12px;
    }

    .information_title::after {
      content: "";
      position: absolute;
      top: 20px;
      left: 0px;
      background-color: #0084ff;
      width: 3px;
      height: 16px;
    }
  }

  .Foot {
    display: flex;
    padding: 10px 27px;
    justify-content: flex-end;
  }
}
</style>
